<template>
  <section class="hero-section" :style="heroBackground">
    <div class="hero-content">
      <div class="container">
        <div class="hero-text">
          <h1> {{ $t('Welcome to') }} {{ websiteSettings.SYSTEM_NAME }}</h1>
          <p class="tagline">{{ websiteSettings.MAIN_TEXT }}</p>
          <router-link to="/e-commerce-web#products" class="cta-button">
            {{ $t('Shop Now') }}
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'HeroSection',
  data() {
    return {
      storeName: 'TechStore'
    }
  },
  computed: {
    ...mapState({
      websiteSettings: state => state.websiteSettings
    }),
    heroBackground() {
      if (!this.websiteSettings?.UI_IMAGE) return {}
      return {
        background: `
          linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)),
          url(${this.getImgUrl(this.websiteSettings.UI_IMAGE)})
        `,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }
    }
  },
  methods: {
    getImgUrl(item) {
      let domain = `${this.$store.state.serverDomain}/storage/`;
      return domain + item;
    },
  }
}
</script>
<style scoped>
.hero-section {
  color: white;
  padding: 80px 0;
  margin-bottom: 40px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-content {
  text-align: center;
}

.hero-text h1 {
  font-size: 48px;
  margin-bottom: 20px;
  font-weight: 700;
}

.tagline {
  font-size: 20px;
  margin-bottom: 30px;
  color: #ddd;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-button {
  display: inline-block;
  padding: 15px 30px;
  background: #2ed573;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.cta-button:hover {
  background: #26c463;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(46, 213, 115, 0.3);
}

@media (max-width: 768px) {
  .hero-section {
    padding: 60px 0;
  }
  
  .hero-text h1 {
    font-size: 36px;
  }
  
  .tagline {
    font-size: 18px;
  }
  
  .cta-button {
    padding: 12px 24px;
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .hero-text h1 {
    font-size: 28px;
  }
  
  .tagline {
    font-size: 16px;
  }
}
</style>